"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var Collections = __importStar(require("typescript-collections"));
exports.default = (function (AccountTeamController, teamsService, userList, account, $q, $timeout) {
    var _a;
    return _a = (function () {
            function UserTeamsManager(refreshUi) {
                this.teamControllers = [];
                this.refreshUi = refreshUi;
            }
            UserTeamsManager.createInstance = function (accountIn, refreshUi, isUsingTeams) {
                var inst = new _a(refreshUi);
                if (!isUsingTeams) {
                    var accountWideTeam = new AccountTeamController("", "Account Team", "account", userList, teamsService, inst, account.pendingInvitations);
                    inst.setAccountWideTeam(accountWideTeam);
                    return $q.resolve(inst);
                }
                return teamsService
                    .getTeamsForAccount()
                    .then(function (accountTeams) {
                    var allControllers = [];
                    var accountTeam;
                    lodash_1.default.map(accountTeams, function (team) {
                        if (team.teamType != "account") {
                            var teamUsers = lodash_1.default.filter(userList, function (u) {
                                return lodash_1.default.includes(team.members, u._id);
                            });
                            allControllers.push(new AccountTeamController(team._id, team.name, team.teamType, teamUsers, teamsService, inst, null));
                        }
                        else {
                            accountTeam = team;
                        }
                    });
                    allControllers = lodash_1.default.sortBy(allControllers, ["teamName"]);
                    inst.setTeamControllers(allControllers);
                    var accountTeamId = "";
                    var accountTeamName = "Account Team";
                    if (accountTeam) {
                        accountTeamId = accountTeam._id;
                        accountTeamName = accountTeam.name;
                    }
                    var accountWideTeam = new AccountTeamController(accountTeamId, accountTeamName, "account", userList, teamsService, inst, account.pendingInvitations);
                    inst.setAccountWideTeam(accountWideTeam);
                    return inst;
                })
                    .catch(function (err) {
                    console.log(err);
                    throw err;
                });
            };
            UserTeamsManager.prototype.setTeamControllers = function (teamControllers) {
                this.teamControllers = teamControllers;
            };
            UserTeamsManager.prototype.setAccountWideTeam = function (accountTeamController) {
                this.accountWideTeam = accountTeamController;
            };
            UserTeamsManager.prototype.getTeamControllers = function () {
                return this.teamControllers || [];
            };
            UserTeamsManager.prototype.getAccountTeamController = function () {
                return this.accountWideTeam;
            };
            UserTeamsManager.prototype.deleteTeam = function (team) {
                return __awaiter(this, void 0, void 0, function () {
                    var err_1;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _b.trys.push([0, 4, , 5]);
                                this.removeController(team);
                                if (!team.teamId) return [3, 2];
                                return [4, teamsService.deleteTeam(team.teamId)];
                            case 1:
                                _b.sent();
                                return [2, this.refreshUi()];
                            case 2: return [2];
                            case 3: return [3, 5];
                            case 4:
                                err_1 = _b.sent();
                                throw err_1;
                            case 5: return [2];
                        }
                    });
                });
            };
            UserTeamsManager.prototype.postUserAdded = function () {
                if (this.hasUsersSelected()) {
                    this.addDeselectionKeyHandler();
                }
                else {
                    this.removeDeselectionKeyHandler();
                }
            };
            UserTeamsManager.prototype.hasUsersSelected = function () {
                var selectedUserCount = lodash_1.default.reduce(this.getTeamControllers(), function (sum, controller) {
                    return sum + controller.getSelectedUsers().size();
                }, 0);
                if (this.accountWideTeam == undefined) {
                    return selectedUserCount > 0;
                }
                else {
                    var accountTeamCount = this.accountWideTeam.getSelectedUsers().size();
                    return selectedUserCount + accountTeamCount > 0;
                }
            };
            UserTeamsManager.prototype.updateUserTeams = function (teams) {
                return __awaiter(this, void 0, Promise, function () {
                    var teamRequestPromises, selectedTeamIds, _loop_1, this_1, selectedTeamIds_1, selectedTeamIds_1_1, teamId;
                    var e_1, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                teamRequestPromises = [];
                                selectedTeamIds = teams.filter(function (t) { return t.isSelected; }).map(function (t) { return t.id; });
                                _loop_1 = function (teamId) {
                                    var teamController = this_1.teamControllers.find(function (t) {
                                        return t.teamId === teamId;
                                    });
                                    if (teamController) {
                                        teamController.addUsersToTeam(this_1.getAllSelectedUserIds());
                                        teamRequestPromises.push(teamController.persist());
                                    }
                                };
                                this_1 = this;
                                try {
                                    for (selectedTeamIds_1 = __values(selectedTeamIds), selectedTeamIds_1_1 = selectedTeamIds_1.next(); !selectedTeamIds_1_1.done; selectedTeamIds_1_1 = selectedTeamIds_1.next()) {
                                        teamId = selectedTeamIds_1_1.value;
                                        _loop_1(teamId);
                                    }
                                }
                                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                finally {
                                    try {
                                        if (selectedTeamIds_1_1 && !selectedTeamIds_1_1.done && (_b = selectedTeamIds_1.return)) _b.call(selectedTeamIds_1);
                                    }
                                    finally { if (e_1) throw e_1.error; }
                                }
                                return [4, $q.all(teamRequestPromises)];
                            case 1:
                                _c.sent();
                                this.refreshUi();
                                return [2];
                        }
                    });
                });
            };
            UserTeamsManager.prototype.removeSelectedUsersFromAllTeams = function () {
                return __awaiter(this, void 0, Promise, function () {
                    var teamRequestPromises, _b, _c, teamController;
                    var e_2, _d;
                    return __generator(this, function (_e) {
                        switch (_e.label) {
                            case 0:
                                teamRequestPromises = [];
                                try {
                                    for (_b = __values(this.teamControllers), _c = _b.next(); !_c.done; _c = _b.next()) {
                                        teamController = _c.value;
                                        teamController.removeUsersFromTeam(this.getAllSelectedUserIds());
                                        teamRequestPromises.push(teamController.persist());
                                    }
                                }
                                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                finally {
                                    try {
                                        if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                                    }
                                    finally { if (e_2) throw e_2.error; }
                                }
                                return [4, $q.all(teamRequestPromises)];
                            case 1:
                                _e.sent();
                                this.refreshUi();
                                return [2];
                        }
                    });
                });
            };
            UserTeamsManager.prototype.deselectUsers = function () {
                var e_3, _b;
                try {
                    for (var _c = __values(this.teamControllers), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var teamController = _d.value;
                        teamController.deselectUsers();
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                if (this.accountWideTeam != undefined) {
                    this.accountWideTeam.deselectUsers();
                }
                this.postUserAdded();
            };
            UserTeamsManager.prototype.getSelectedTeamsMap = function () {
                var e_4, _b;
                var membershipMap = [];
                var memberIds = this.getAllSelectedUserIds();
                try {
                    for (var _c = __values(this.teamControllers), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var teamController = _d.value;
                        var teamMemberIds = lodash_1.default.map(teamController.getMembers(), function (member) {
                            return member._id;
                        });
                        var matches = lodash_1.default.intersection(teamMemberIds, memberIds);
                        if (matches.length == memberIds.length) {
                            membershipMap.push({
                                id: teamController.teamId,
                                name: teamController.teamName,
                                selected: 1,
                            });
                        }
                        else if (matches.length > 0) {
                            membershipMap.push({
                                id: teamController.teamId,
                                name: teamController.teamName,
                                selected: 2,
                            });
                        }
                        else {
                            membershipMap.push({
                                id: teamController.teamId,
                                name: teamController.teamName,
                                selected: 0,
                            });
                        }
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
                return membershipMap;
            };
            UserTeamsManager.prototype.getUsersTeams = function (userId) {
                var e_5, _b;
                var teams = [];
                try {
                    for (var _c = __values(this.teamControllers), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var team = _d.value;
                        if (team.getMemberIds().includes(userId)) {
                            teams.push(team);
                        }
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
                return teams;
            };
            UserTeamsManager.prototype.addNewController = function () {
                this.teamControllers.unshift(new AccountTeamController(undefined, "", "normal", [], teamsService, this, null));
            };
            UserTeamsManager.prototype.removeController = function (teamController) {
                lodash_1.default.pull(this.teamControllers, teamController);
                return this.teamControllers;
            };
            UserTeamsManager.prototype.numRemainingSeats = function () {
                var totalAvailable = account.plan.seats.included + account.additionalSeats;
                var totalUsed = userList.length + account.pendingInvitations.length;
                return totalAvailable - totalUsed;
            };
            UserTeamsManager.prototype.getAllSelectedUserIds = function () {
                var memberIds = new Collections.Set();
                if (this.accountWideTeam != undefined) {
                    memberIds.union(this.accountWideTeam.getSelectedUsers());
                }
                lodash_1.default.map(this.getTeamControllers(), function (controller) {
                    memberIds.union(controller.getSelectedUsers());
                });
                return memberIds.toArray();
            };
            UserTeamsManager.prototype.getAllTeamUsers = function () {
                var allTeamedUsers = lodash_1.default.uniqBy(lodash_1.default.flatMap(this.teamControllers, function (accountTeamController) {
                    return accountTeamController.teamMembers;
                }), function (u) {
                    return u.email;
                });
                return allTeamedUsers;
            };
            UserTeamsManager.prototype.addDeselectionKeyHandler = function () {
                var _this = this;
                $("body").on("keydown.teamSelect", function (e) {
                    if (e.keyCode == _a.ESC_KEY_CODE) {
                        $timeout(function () {
                            _this.deselectUsers();
                        });
                    }
                });
            };
            UserTeamsManager.prototype.removeDeselectionKeyHandler = function () {
                $("body").off("keydown.teamSelect");
            };
            return UserTeamsManager;
        }()),
        _a.ESC_KEY_CODE = 27,
        _a;
});
